export default {
    importantButton: {
        padding: "17px 70px",
        fontSize: "18px",
        "@media (max-width: 611px)": {
            width: "100%",
            marginBottom: "32px",
            borderRadius: '0px'
        }
    }
}
